// extracted by mini-css-extract-plugin
export default {"container":"styles_container__EyR50","form":"styles_form__TLvei","link":"styles_link__1SKvh","submitActions":"styles_submitActions__Ue4Ji"};